const en = {
  fixed: 'Fixed',
  default: 'Default',
  save_as_custom_field: 'Save as custom field',
  kba: 'KBA',
  analyzing_: 'Analyzing...',
  download: 'Download',
  downloading_: 'Downloading...',
  view: 'View',
  autodetect_fields: 'Autodetect Fields',
  payment_link: 'Payment link',
  strikeout: 'Strikeout',
  draw_strikethrough_the_document: 'Draw strikethrough the document',
  quantity: 'Quantity',
  prefillable: 'Prefillable',
  signature_id: 'Signature ID',
  error_message: 'Error message',
  length: 'Length',
  min: 'Min',
  max: 'Max',
  font: 'Font',
  party: 'Party',
  date_signed: 'Date Signed',
  method: 'Method',
  reorder_fields: 'Reorder fields',
  verify_id: 'Verify ID',
  obtain_qualified_electronic_signature_with_the_trusted_provider_click_to_learn_more: 'Obtain qualified electronic signature (QeS) with the trusted provider. Click to learn more.',
  editable: 'Editable',
  recurrent: 'Recurrent',
  one_off: 'One-off',
  search_field: 'Search field',
  field_not_found: 'Field not found',
  clear: 'Clear',
  align: 'Align',
  resize: 'Resize',
  width: 'Width',
  height: 'Height',
  add_all_required_fields_to_continue: 'Add all required fields to continue',
  uploaded_pdf_contains_form_fields_keep_or_remove_them: 'Uploaded PDF contains form fields. Keep or remove them?',
  keep: 'Keep',
  left: 'Left',
  heading: 'Heading',
  validation: 'Validation',
  add_blank_page: 'Add blank page',
  right: 'Right',
  center: 'Center',
  description: 'Description',
  add_signing_description: 'Add signing description',
  template_description_placeholder: 'Description for signers. Use [link text](https://example.com) or paste a URL.',
  signing_description_hint: 'Shown below the document title when signing. Links open in a new tab.',
  display_title: 'Display title',
  with_logo: 'With logo',
  unchecked: 'Unchecked',
  price: 'Price',
  type_value: 'Type value',
  equal: 'Equal',
  not_equal: 'Not equal',
  greater_than: 'Greater than',
  less_than: 'Less than',
  contains: 'Contains',
  does_not_contain: 'Does not contain',
  not_empty: 'Not empty',
  empty: 'Empty',
  select_field_: 'Select field...',
  select_value_: 'Select value...',
  remove_condition: 'Remove condition',
  add_condition: 'Add condition',
  are_you_sure_: 'Are you sure?',
  sign_yourself: 'Sign yourself',
  field_types: 'Field types',
  set_signing_date: 'Set signing date',
  signing_date: 'Signing Date',
  send: 'Send',
  remove: 'Remove',
  edit: 'Edit',
  settings: 'Settings',
  up: 'Up',
  down: 'Down',
  checked: 'Checked',
  save: 'Save',
  cancel: 'Cancel',
  any: 'Any',
  drawn: 'Drawn',
  drawn_or_typed: 'Drawn or Typed',
  drawn_or_upload: 'Drawn or Upload',
  upload: 'Upload',
  formula: 'Formula',
  fixed_value: 'Fixed value',
  condition_formula_hint: 'Combine number fields with +, −, ×, ÷. Example: {{Field A}} + {{Field B}}',
  condition_formula_placeholder: '{{Field A}} + {{Field B}} - {{Field C}}',
  typed: 'Typed',
  draw_field_on_the_document: 'Draw a field on the document',
  click_to_upload: 'Click to upload',
  or_drag_and_drop_files: 'or drag and drop files',
  uploading: 'Uploading',
  processing_: 'Processing...',
  add_pdf_documents_or_images: 'Add PDF documents or images',
  add_documents_or_images: 'Add documents or images',
  add_a_new_document: 'Add a new document',
  replace_existing_document: 'Replace existing document',
  clone_and_replace_documents: 'Clone and replace documents',
  required: 'Required',
  default_value: 'Default value',
  format: 'Format',
  read_only: 'Read-only',
  page: 'Page',
  draw_new_area: 'Draw new area',
  copy_to_all_pages: 'Copy to all pages',
  more: 'More',
  add_option: 'Add option',
  option: 'Option',
  options: 'Options',
  condition: 'Condition',
  first_party: 'First Party',
  second_party: 'Second Party',
  third_party: 'Third Party',
  fourth_party: 'Fourth Party',
  fifth_party: 'Fifth Party',
  sixth_party: 'Sixth Party',
  seventh_party: 'Seventh Party',
  eighth_party: 'Eighth Party',
  ninth_party: 'Ninth Party',
  tenth_party: 'Tenth Party',
  eleventh_party: 'Eleventh Party',
  twelfth_party: 'Twelfth Party',
  thirteenth_party: 'Thirteenth Party',
  fourteenth_party: 'Fourteenth Party',
  fifteenth_party: 'Fifteenth Party',
  sixteenth_party: 'Sixteenth Party',
  seventeenth_party: 'Seventeenth Party',
  eighteenth_party: 'Eighteenth Party',
  nineteenth_party: 'Nineteenth Party',
  twentieth_party: 'Twentieth Party',
  draw: 'Draw',
  add: 'Add',
  or_add_field_without_drawing: 'Or add field without drawing',
  text: 'Text',
  number: 'Number',
  signature: 'Signature',
  initials: 'Initials',
  date: 'Date',
  image: 'Image',
  file: 'File',
  select: 'Select',
  checkbox: 'Checkbox',
  multiple: 'Multiple',
  radio: 'Radio',
  cells: 'Cells',
  stamp: 'Stamp',
  payment: 'Payment',
  phone: 'Phone',
  text_field: 'Text Field',
  signature_field: 'Signature Field',
  initials_field: 'Initials Field',
  date_field: 'Date Field',
  number_field: 'Number Field',
  image_field: 'Image Field',
  file_field: 'File Field',
  select_field: 'Select Field',
  checkbox_field: 'Checkbox Field',
  multiple_field: 'Multiple Select Field',
  radio_field: 'Radio Group Field',
  cells_field: 'Cells Field',
  stamp_field: 'Stamp Field',
  payment_field: 'Payment Field',
  phone_field: 'Phone Field',
  draw_a_text_field_on_the_page_with_a_mouse: 'Draw a text field on the page with a mouse',
  drag_and_drop_any_other_field_type_on_the_page: 'Drag & drop any other field type on the page',
  click_on_the_field_type_above_to_start_drawing_it: 'Click on the field type above to start drawing it',
  please_draw_fields_to_prepare_the_document: 'Please draw fields to prepare the document.',
  only_pdf_and_images_are_supported: 'Only PDF and images are supported.',
  unlock_sms_verified_phone_number_field_with_paid_plan_use_text_field_for_phone_numbers_without_verification: 'Unlock SMS-verified phone number field with paid plan. Use text field for phone numbers without verification.',
  available_only_in_pro: 'Available only in Pro',
  failed_to_download_files: 'Failed to download files',
  please_add_fields_for_the_submitter_name_or_remove_the_submitter_name_if_not_needed: 'Please add fields for the {submitter_name}. Or, remove the {submitter_name} if not needed.',
  draw_field: 'Draw {field} Field',
  replace: 'Replace',
  uploading_: 'Uploading...',
  add_document: 'Add document',
  none: 'None',
  ssn: 'SSN',
  ein: 'EIN',
  email: 'Email',
  url: 'URL',
  zip: 'ZIP',
  custom: 'Custom',
  numbers_only: 'Numbers only',
  letters_only: 'Letters only',
  regexp_validation: 'Regexp validation',
  custom_validation: 'Custom Validation',
  length_validation: 'Length Validation',
  number_range: 'Number Range',
  enter_pdf_password: 'Enter PDF password',
  wrong_password: 'Wrong password',
  currency: 'Currency',
  save_and_preview: 'Save and preview',
  preferences: 'Preferences',
  available_in_pro: 'Available in Pro',
  some_fields_are_missing_in_the_formula: 'Some fields are missing in the formula.',
  learn_more: 'Learn more',
  and: 'and',
  or: 'or',
  start_a_quick_tour_to_learn_how_to_create_an_send_your_first_document: 'Start a quick tour to learn how to create an send your first document',
  start_tour: 'Start Tour',
  or_add_from: 'Or add from',
  sync: 'Sync',
  syncing: 'Syncing...',
  copy: 'Copy',
  paste: 'Paste',
  select_fields: 'Select Fields',
  draw_fields: 'Draw Fields',
  align_left: 'Align Left',
  align_right: 'Align Right',
  align_top: 'Align Top',
  align_bottom: 'Align Bottom',
  fields_selected: '{count} Fields Selected',
  field_added: '{count} Field Added',
  fields_added: '{count} Fields Added'
}
const vi = {
  fixed: 'Cố định',
  default: 'Mặc định',
  save_as_custom_field: 'Lưu làm trường tùy chỉnh',
  kba: 'KBA',
  analyzing_: 'Đang phân tích...',
  download: 'Tải xuống',
  downloading_: 'Đang tải xuống...',
  view: 'Xem',
  autodetect_fields: 'Tự động phát hiện trường',
  payment_link: 'Liên kết thanh toán',
  strikeout: 'Gạch ngang',
  draw_strikethrough_the_document: 'Vẽ gạch ngang trên tài liệu',
  quantity: 'Số lượng',
  prefillable: 'Có thể điền trước',
  signature_id: 'ID chữ ký',
  error_message: 'Thông báo lỗi',
  length: 'Độ dài',
  min: 'Tối thiểu',
  max: 'Tối đa',
  font: 'Phông chữ',
  party: 'Bên',
  date_signed: 'Ngày ký',
  method: 'Phương pháp',
  reorder_fields: 'Sắp xếp lại các trường',
  verify_id: 'Xác minh ID',
  obtain_qualified_electronic_signature_with_the_trusted_provider_click_to_learn_more: 'Lấy chữ ký điện tử có tư cách (QeS) từ nhà cung cấp được tin tưởng. Nhấp để tìm hiểu thêm.',
  editable: 'Có thể chỉnh sửa',
  recurrent: 'Định kỳ',
  one_off: 'Một lần',
  search_field: 'Tìm kiếm trường',
  field_not_found: 'Không tìm thấy trường',
  clear: 'Xóa',
  align: 'Căn chỉnh',
  resize: 'Thay đổi kích thước',
  width: 'Chiều rộng',
  height: 'Chiều cao',
  add_all_required_fields_to_continue: 'Thêm tất cả các trường bắt buộc để tiếp tục',
  uploaded_pdf_contains_form_fields_keep_or_remove_them: 'PDF đã tải lên chứa các trường biểu mẫu. Giữ hay xóa chúng?',
  keep: 'Giữ',
  left: 'Trái',
  heading: 'Tiêu đề',
  validation: 'Xác minh',
  add_blank_page: 'Thêm trang trống',
  right: 'Phải',
  center: 'Giữa',
  description: 'Mô tả',
  add_signing_description: 'Thêm mô tả cho người ký',
  template_description_placeholder: 'Mô tả hiển thị cho người ký trên trang ký',
  signing_description_hint: 'Mô tả này hiển thị trong hộp thông tin dưới tiêu đề tài liệu khi ai đó ký.',
  display_title: 'Tiêu đề hiển thị',
  with_logo: 'Với logo',
  unchecked: 'Chưa đánh dấu',
  price: 'Giá',
  type_value: 'Nhập giá trị',
  equal: 'Bằng',
  not_equal: 'Không bằng',
  greater_than: 'Lớn hơn',
  less_than: 'Nhỏ hơn',
  contains: 'Chứa',
  does_not_contain: 'Không chứa',
  not_empty: 'Không trống',
  empty: 'Trống',
  select_field_: 'Chọn trường...',
  select_value_: 'Chọn giá trị...',
  remove_condition: 'Xóa điều kiện',
  add_condition: 'Thêm điều kiện',
  are_you_sure_: 'Bạn có chắc chắn?',
  sign_yourself: 'Tự ký',
  field_types: 'Loại trường',
  set_signing_date: 'Đặt ngày ký',
  signing_date: 'Ngày ký',
  send: 'Gửi',
  remove: 'Xóa',
  edit: 'Chỉnh sửa',
  settings: 'Cài đặt',
  up: 'Lên',
  down: 'Xuống',
  checked: 'Đã chọn',
  save: 'Lưu',
  cancel: 'Hủy',
  any: 'Bất kỳ',
  drawn: 'Được vẽ',
  drawn_or_typed: 'Được vẽ hoặc nhập',
  drawn_or_upload: 'Được vẽ hoặc tải lên',
  upload: 'Tải lên',
  formula: 'Công thức',
  fixed_value: 'Giá trị cố định',
  condition_formula_hint: 'Kết hợp các trường số với +, −, ×, ÷. Ví dụ: {{Trường A}} + {{Trường B}}',
  condition_formula_placeholder: '{{Trường A}} + {{Trường B}} - {{Trường C}}',
  typed: 'Được nhập',
  draw_field_on_the_document: 'Vẽ một trường trên tài liệu',
  click_to_upload: 'Nhấp để tải lên',
  or_drag_and_drop_files: 'hoặc kéo và thả tệp',
  uploading: 'Đang tải lên',
  processing_: 'Đang xử lý...',
  add_pdf_documents_or_images: 'Thêm tài liệu PDF hoặc hình ảnh',
  add_documents_or_images: 'Thêm tài liệu hoặc hình ảnh',
  add_a_new_document: 'Thêm tài liệu mới',
  replace_existing_document: 'Thay thế tài liệu hiện có',
  clone_and_replace_documents: 'Sao chép và thay thế tài liệu',
  required: 'Bắt buộc',
  default_value: 'Giá trị mặc định',
  format: 'Định dạng',
  read_only: 'Chỉ đọc',
  page: 'Trang',
  draw_new_area: 'Vẽ khu vực mới',
  copy_to_all_pages: 'Sao chép sang tất cả các trang',
  more: 'Thêm',
  add_option: 'Thêm tùy chọn',
  option: 'Tùy chọn',
  options: 'Các tùy chọn',
  condition: 'Điều kiện',
  first_party: 'Bên thứ nhất',
  second_party: 'Bên thứ hai',
  third_party: 'Bên thứ ba',
  fourth_party: 'Bên thứ tư',
  fifth_party: 'Bên thứ năm',
  sixth_party: 'Bên thứ sáu',
  seventh_party: 'Bên thứ bảy',
  eighth_party: 'Bên thứ tám',
  ninth_party: 'Bên thứ chín',
  tenth_party: 'Bên thứ mười',
  eleventh_party: 'Bên thứ mười một',
  twelfth_party: 'Bên thứ mười hai',
  thirteenth_party: 'Bên thứ mười ba',
  fourteenth_party: 'Bên thứ mười bốn',
  fifteenth_party: 'Bên thứ mười lăm',
  sixteenth_party: 'Bên thứ mười sáu',
  seventeenth_party: 'Bên thứ mười bảy',
  eighteenth_party: 'Bên thứ mười tám',
  nineteenth_party: 'Bên thứ mười chín',
  twentieth_party: 'Bên thứ hai mươi',
  draw: 'Vẽ',
  add: 'Thêm',
  or_add_field_without_drawing: 'Hoặc thêm trường mà không cần vẽ',
  text: 'Văn bản',
  number: 'Số',
  signature: 'Chữ ký',
  initials: 'Chữ cái đầu',
  date: 'Ngày',
  image: 'Hình ảnh',
  file: 'Tệp',
  select: 'Chọn',
  checkbox: 'Hộp kiểm',
  multiple: 'Nhiều',
  radio: 'Nút radio',
  cells: 'Ô',
  stamp: 'Dấu',
  payment: 'Thanh toán',
  phone: 'Điện thoại',
  text_field: 'Trường văn bản',
  signature_field: 'Trường chữ ký',
  initials_field: 'Trường chữ cái đầu',
  date_field: 'Trường ngày',
  number_field: 'Trường số',
  image_field: 'Trường hình ảnh',
  file_field: 'Trường tệp',
  select_field: 'Trường chọn',
  checkbox_field: 'Trường hộp kiểm',
  multiple_field: 'Trường chọn nhiều',
  radio_field: 'Trường nhóm nút radio',
  cells_field: 'Trường ô',
  stamp_field: 'Trường dấu',
  payment_field: 'Trường thanh toán',
  phone_field: 'Trường điện thoại',
  draw_a_text_field_on_the_page_with_a_mouse: 'Vẽ trường văn bản trên trang bằng chuột',
  drag_and_drop_any_other_field_type_on_the_page: 'Kéo và thả bất kỳ loại trường nào khác trên trang',
  click_on_the_field_type_above_to_start_drawing_it: 'Nhấp vào loại trường ở trên để bắt đầu vẽ',
  please_draw_fields_to_prepare_the_document: 'Vui lòng vẽ các trường để chuẩn bị tài liệu.',
  only_pdf_and_images_are_supported: 'Chỉ hỗ trợ PDF và hình ảnh.',
  unlock_sms_verified_phone_number_field_with_paid_plan_use_text_field_for_phone_numbers_without_verification: 'Mở khóa trường số điện thoại được xác minh bằng SMS với gói trả phí. Sử dụng trường văn bản cho số điện thoại không xác minh.',
  available_only_in_pro: 'Chỉ khả dụng trong bản Pro',
  failed_to_download_files: 'Không tải xuống được tệp',
  please_add_fields_for_the_submitter_name_or_remove_the_submitter_name_if_not_needed: 'Vui lòng thêm các trường cho {submitter_name}. Hoặc xóa {submitter_name} nếu không cần thiết.',
  draw_field: 'Vẽ trường {field}',
  replace: 'Thay thế',
  uploading_: 'Đang tải lên...',
  add_document: 'Thêm tài liệu',
  none: 'Không có',
  ssn: 'SSN',
  ein: 'EIN',
  email: 'Email',
  url: 'URL',
  zip: 'ZIP',
  custom: 'Tùy chỉnh',
  numbers_only: 'Chỉ số',
  letters_only: 'Chỉ chữ cái',
  regexp_validation: 'Xác minh Regexp',
  custom_validation: 'Xác minh tùy chỉnh',
  length_validation: 'Xác minh độ dài',
  number_range: 'Khoảng số',
  enter_pdf_password: 'Nhập mật khẩu PDF',
  wrong_password: 'Mật khẩu sai',
  currency: 'Tiền tệ',
  save_and_preview: 'Lưu và xem trước',
  preferences: 'Tùy chọn',
  available_in_pro: 'Khả dụng trong bản Pro',
  some_fields_are_missing_in_the_formula: 'Một số trường không có trong công thức.',
  learn_more: 'Tìm hiểu thêm',
  and: 'và',
  or: 'hoặc',
  start_a_quick_tour_to_learn_how_to_create_an_send_your_first_document: 'Bắt đầu tour nhanh để tìm hiểu cách tạo và gửi tài liệu đầu tiên của bạn',
  start_tour: 'Bắt đầu tour',
  or_add_from: 'Hoặc thêm từ',
  sync: 'Đồng bộ',
  syncing: 'Đang đồng bộ...',
  copy: 'Sao chép',
  paste: 'Dán',
  select_fields: 'Chọn các trường',
  draw_fields: 'Vẽ các trường',
  align_left: 'Căn trái',
  align_right: 'Căn phải',
  align_top: 'Căn trên',
  align_bottom: 'Căn dưới',
  fields_selected: '{count} trường được chọn',
  field_added: 'Đã thêm {count} trường',
  fields_added: 'Đã thêm {count} trường'
}

export { en, vi }
